import { render } from "./addEdit.vue?vue&type=template&id=24f717ff"
import script from "./addEdit.vue?vue&type=script&lang=js"
export * from "./addEdit.vue?vue&type=script&lang=js"

import exportComponent from "/builds/spsgn/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QItem,QInput,QBtn,QPopupProxy,QDate});qInstall(script, 'directives', {ClosePopup});
